import { render } from "./StorageHub.vue?vue&type=template&id=2812d643&scoped=true"
import script from "./StorageHub.vue?vue&type=script&lang=js"
export * from "./StorageHub.vue?vue&type=script&lang=js"

import "./StorageHub.vue?vue&type=style&index=0&id=2812d643&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2812d643"]])

export default __exports__